

export const goodsManageListNewData = [
  {
    id: 'baseInfo',
    title: '添加用户',
    footerShow:'special',
    data: [
      {
        id: 'realname',
        name: '姓名',
        placeholder: '请输入姓名',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'realname'
      },
      {
        id: 'name',
        name: '登录名',
        placeholder: '请输入登录名',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'name'
      },
      {
        id: 'mobile',
        name: '手机号',
        placeholder: '请输入手机号',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'mobile'
      },
      {
        id: 'password',
        name: '密码',
        placeholder: '请输入密码',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'password'
      },
      {
        id: 'email',
        name: 'Email',
        placeholder: '请输入Email',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'email'
      },
      {
        id: 'workunit',
        name: '所属单位',
        placeholder: '请选择所属单位',
        type: 'select',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'workunit'
      }
    ]
  }
];
